import { useRef } from 'react';

import { observer } from 'mobx-react';
import styled from 'styled-components';
import { Form, notification } from 'antd';

import UserStore from 'stores/UserStore';
import { Logger } from 'stores/Classes';

import { ShopRolesApi } from 'stores/Classes/UserObject';
import { cancelButtonProps, StyledPitstopModal } from './common/styled';
import AddUserForm from './AddUserForm';
import { handleDuplicateEmailError } from './common/utils';
import { AppStore } from 'stores';
import PrintLoginCredentialsButton from 'components/Users/PrintLoginCredentialsButton';
import { formatPhoneNumber } from 'v3/utils/formaters';

export const HidePrintButton = styled.div`
  display: none;
`;

const shopApiRoles = {
  customer: ShopRolesApi.driver,
  dealership: ShopRolesApi.fleetManager,
};

const AddUserModal = (props) => {
  const { id, inviterId, onAddUsers } = props;
  const [form] = Form.useForm();

  const printLoginCredentialsButtonRef = useRef(null);

  const handleOk = () => {
    if (!form) return;
    form
      .validateFields()
      .then((values) => handleFormSubmit(values))
      .catch((err) => {
        // Form validation failed
        console.error('Validation failed:', err);
      });
  };

  const handleFormSubmit = async (values) => {
    const user = createUserObject(values);

    try {
      const userObj = await addUserToShop(user);

      notification.success({
        message: 'User added',
        description: (
          <>
            <p>Continue adding users or close the modal.</p>
            <HidePrintButton>
              <PrintLoginCredentialsButton
                ref={printLoginCredentialsButtonRef}
                label="Print login credentials & instructions"
                type="link"
                users={[userObj]}
              />
            </HidePrintButton>
          </>
        ),
      });

      if (onAddUsers) {
        onAddUsers();
      }
      form.resetFields();
      form.setFieldValue('phone', '');

      if (
        values.printLoginCredentials &&
        printLoginCredentialsButtonRef.current
      ) {
        await printLoginCredentialsButtonRef.current.handlePrint();
      }
    } catch (error) {
      Logger.error(error);
      handleAddUserError(error, user.email);
    }
  };

  const createUserObject = (values) => {
    const {
      firstName,
      lastName,
      email,
      phone,
      fleet,
      role,
      password,
      sendLoginCredentials,
    } = values;

    return {
      shopId: fleet,
      inviterId: inviterId,
      firstName,
      lastName,
      email,
      username: email,
      phone: formatPhoneNumber(phone?.toString()),
      password,
      role,
      shopRole: shopApiRoles[role] || role,
      isSendCredentialsByPhone: sendLoginCredentials,
    };
  };

  const addUserToShop = async (user) => {
    return await UserStore.addUserToShop(user);
  };

  const handleAddUserError = (error, email) => {
    const message = handleDuplicateEmailError(error, email);
    AppStore.addError(message);
  };

  return (
    <StyledPitstopModal
      id={id}
      title="Add User"
      width={590}
      okText="Add User"
      closable
      isManualClose
      onOk={handleOk}
      onCancel={() => {}}
      cancelButtonProps={cancelButtonProps}
    >
      <AddUserForm form={form} />
    </StyledPitstopModal>
  );
};

export default observer(AddUserModal);
